var _ = require('lodash')
var Media = require('./Media.js')

export default {
    methods: {
        /* Parse Images and Documents from the object into an array (images first)*/
        parseMedia: function (object, width = null, height = null) {
            // sort by order
            var media = []

            media = media.concat(this.parseImages(object, width, height))
            media = media.concat(this.parseDocuments(object, width, height))

            return media
        },

        /* Parse Images from the object into an array */
        parseImages: function (object, width = null, height = null) {
            var images = []
            var is_graphic = false

            object.images.forEach(function (image) {
                image.type = 'image'
                var media = new Media(image, width, height, true)
                if (media.is_graphic) {
                    is_graphic = true
                }

                images.push(media)
            })

            // If graphic put graphic warning on top
            if (is_graphic) {
                var warning = {
                    path: '/images/for_records/content_warning.svg',
                    title: 'Warning: Graphic Content',
                    description: 'Images may contain graphic content',
                    type: 'svg',
                    order: -1, // Always first
                }

                images.unshift(new Media(warning, width, height))
            }

            return _.sortBy(images, 'order')
        },

        /* Parse Documents from the object into an array */
        parseDocuments: function (object, width = null, height = null) {
            var docs = []

            object.media.forEach(function (media) {
                media.title = media.caption
                docs.push(new Media(media, width, height, true))
            })

            return _.sortBy(docs, 'order')
        },
        addFolderImage: function (object, media = [], width = null, height = null) {
            var indices_with_images = [
                'archival_collection',
                'archival_series',
                'archival_fileunit',
                'association',
                'vessel',
                'exhibit'
            ]

            if (indices_with_images.indexOf(object._index) > -1) {
                var image = {
                    path: '/images/for_records/folder_icon.svg',
                    title: 'Click to view Content',
                    description: '',
                    non_viewable: true,
                    type: 'svg',
                    order: -1,
                }

                media.unshift(new Media(image, width, height, false, true))
            }

            return media
        },
        addNoImage: function (object, media = [], width = null, height = null) {
            var image = {
                path: '/images/for_records/no_image_available.svg',
                title: 'No Images Available',
                description: '',
                type: 'svg',
                order: -1,
            }

            if (media.length == 0) {
                media.unshift(new Media(image, width, height))
            }

            return media
        }

    }
}
